import {getCurrentYear} from '../../utils/commons'
import EagleReviewsLogo from './logo'
import {eagleReviewsStylesUS} from './styles'

const baseConfig = {
  domainName: 'eaglereviews' as const,
  domainType: 'maga' as const,
  siteName: 'Eagle Reviews',
  logo: <EagleReviewsLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/eaglereviews.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-H0MFDEZN3Q',
    camelCaseUrl: 'EagleReviews.com',
    title: (category: string, _count: string) =>
      `${category} Reviewed | Best Products of ${getCurrentYear()} | Eagle-reviews.com - Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the most trusted product picks for Americans at Eagle-Reviews.com. Our expert reviews highlight gear and gadgets chosen with American pride and USA-worthy standards.`,
    styles: eagleReviewsStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
